export const ORDERS_PER_PAGE_OPTIONS = [50, 100, 200]
export const RECENT_ORDERS_COUNT = 4
export const ORDERS_PAGING_LOADING = 'ORDERS_PAGING_LOADING'
export const PAYMENT_FAILED = 'PAYMENT_FAILED'
export const CONTACT_SUPPORT = 'CONTACT_SUPPORT'
export const MUST_AGREE_MESSAGE =
  'You must agree to the above terms of service and privacy policy to place the order.'
